import React, { createContext, useContext, useState } from 'react';

import RedirectPendingModal from '.';

interface RedirectPendingModalContextValue {
  /**
   * Indicates what we are redirecting to, e.g. `v1.0`. When truthy, the modal
   * is toggled open. When set to an empty string, the modal is closed.
   */
  redirectPendingModalValue: string;
  /**
   * Open or close the modal by setting a label for what we are redirecting to.
   * @example setRedirectPendingModalValue('v10.0');
   */
  setRedirectPendingModalValue: React.Dispatch<
    React.SetStateAction<RedirectPendingModalContextValue['redirectPendingModalValue']>
  >;
}

const RedirectPendingModalContext = createContext<RedirectPendingModalContextValue | null>(null);
RedirectPendingModalContext.displayName = 'RedirectPendingModalContext';

export const RedirectPendingModalProvider: React.FC = ({ children }) => {
  const [redirectPendingModalValue, setRedirectPendingModalValue] = useState('');

  return (
    <RedirectPendingModalContext.Provider value={{ redirectPendingModalValue, setRedirectPendingModalValue }}>
      {children}
      <RedirectPendingModal />
    </RedirectPendingModalContext.Provider>
  );
};

/**
 * Returns state that controls whether `<RedirectPendingModal>` is open.
 */
export const useRedirectPendingModalContext = () => {
  const value = useContext(RedirectPendingModalContext);
  if (!value) throw new Error('RedirectPendingModalProvider is missing');
  return value;
};
